import request from "../../../../utils/api";

const customer_url = "api/v1/companies";
const product_url = "api/v1/customers";

export const getCustomers = (company_id, params) => request(`${customer_url}/${company_id}/customers`, { params });
export const createCustomer = (company_id, body) => request(`${customer_url}/${company_id}/customers`, { method: "post", body });
export const updateCustomer = (company_id, customer_id, body) => request(`${customer_url}/${company_id}/customers/${customer_id}`, { method: "put", body });
export const deleteCustomer = (company_id, customer_id) => request(`${customer_url}/${company_id}/customers/${customer_id}`, { method: "delete" });
export const getProducts = (customer_id, params) => request(`${product_url}/${customer_id}/customer-products`, { params });
export const assignProduct = (customer_id, body) => request(`${product_url}/${customer_id}/customer-products`, { method: "post", body });
export const updateProduct = (customer_id, product_id, body) => request(`${product_url}/${customer_id}/customer-products/${product_id}`, { method: "put", body });
export const deleteProduct = (customer_id, product_id) => request(`${product_url}/${customer_id}/customer-products/${product_id}`, { method: "delete" });


// WEBPACK FOOTER //
// ./src/modules/company/pages/customer/service.js